import { createApp } from 'vue'
import ElementPlus from 'element-plus'
// import 'element-plus/theme-chalk/src/dark/css-vars.scss'
import './element-dark.scss'
import './element.scss'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import Markdown from 'vue3-markdown-it';
import * as Sentry from "@sentry/vue";
import Clarity from '@microsoft/clarity';
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
const app = createApp(App).use(pinia).use(router).use(Markdown)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(ElementPlus)


app.mount('#app')

Sentry.init({
  app,
  dsn: "https://58a607b471348777bfb244032d89a915@o4508896291192833.ingest.de.sentry.io/4508897645690960",
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const projectId = "qha4o5pl25"

Clarity.init(projectId);